/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaderboardHistoryTopThreeEntry } from './LeaderboardHistoryTopThreeEntry';
import {
    LeaderboardHistoryTopThreeEntryFromJSON,
    LeaderboardHistoryTopThreeEntryFromJSONTyped,
    LeaderboardHistoryTopThreeEntryToJSON,
    LeaderboardHistoryTopThreeEntryToJSONTyped,
} from './LeaderboardHistoryTopThreeEntry';

/**
 * 
 * @export
 * @interface LeaderboardHistoryEntry
 */
export interface LeaderboardHistoryEntry {
    /**
     * 
     * @type {number}
     * @memberof LeaderboardHistoryEntry
     */
    periodNumber: number;
    /**
     * 
     * @type {string}
     * @memberof LeaderboardHistoryEntry
     */
    periodType: string;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardHistoryEntry
     */
    startAt: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardHistoryEntry
     */
    endAt: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardHistoryEntry
     */
    totalParticipants: number;
    /**
     * 
     * @type {number}
     * @memberof LeaderboardHistoryEntry
     */
    highestScore: number;
    /**
     * 
     * @type {Array<LeaderboardHistoryTopThreeEntry>}
     * @memberof LeaderboardHistoryEntry
     */
    topThree: Array<LeaderboardHistoryTopThreeEntry>;
    /**
     * Authenticated caller's finish rank in this period. Absent when unauthenticated or the caller didn't place.
     * @type {number}
     * @memberof LeaderboardHistoryEntry
     */
    myRank?: number;
    /**
     * Authenticated caller's final score in this period.
     * @type {number}
     * @memberof LeaderboardHistoryEntry
     */
    myFinalValue?: number;
    /**
     * Human-readable summary of what the caller won this period.
     * @type {string}
     * @memberof LeaderboardHistoryEntry
     */
    myPrizeSummary?: string;
}

/**
 * Check if a given object implements the LeaderboardHistoryEntry interface.
 */
export function instanceOfLeaderboardHistoryEntry(value: object): value is LeaderboardHistoryEntry {
    if (!('periodNumber' in value) || value['periodNumber'] === undefined) return false;
    if (!('periodType' in value) || value['periodType'] === undefined) return false;
    if (!('startAt' in value) || value['startAt'] === undefined) return false;
    if (!('endAt' in value) || value['endAt'] === undefined) return false;
    if (!('totalParticipants' in value) || value['totalParticipants'] === undefined) return false;
    if (!('highestScore' in value) || value['highestScore'] === undefined) return false;
    if (!('topThree' in value) || value['topThree'] === undefined) return false;
    return true;
}

export function LeaderboardHistoryEntryFromJSON(json: any): LeaderboardHistoryEntry {
    return LeaderboardHistoryEntryFromJSONTyped(json, false);
}

export function LeaderboardHistoryEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeaderboardHistoryEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'periodNumber': json['periodNumber'],
        'periodType': json['periodType'],
        'startAt': json['startAt'],
        'endAt': json['endAt'],
        'totalParticipants': json['totalParticipants'],
        'highestScore': json['highestScore'],
        'topThree': ((json['topThree'] as Array<any>).map(LeaderboardHistoryTopThreeEntryFromJSON)),
        'myRank': json['myRank'] == null ? undefined : json['myRank'],
        'myFinalValue': json['myFinalValue'] == null ? undefined : json['myFinalValue'],
        'myPrizeSummary': json['myPrizeSummary'] == null ? undefined : json['myPrizeSummary'],
    };
}

export function LeaderboardHistoryEntryToJSON(json: any): LeaderboardHistoryEntry {
    return LeaderboardHistoryEntryToJSONTyped(json, false);
}

export function LeaderboardHistoryEntryToJSONTyped(value?: LeaderboardHistoryEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'periodNumber': value['periodNumber'],
        'periodType': value['periodType'],
        'startAt': value['startAt'],
        'endAt': value['endAt'],
        'totalParticipants': value['totalParticipants'],
        'highestScore': value['highestScore'],
        'topThree': ((value['topThree'] as Array<any>).map(LeaderboardHistoryTopThreeEntryToJSON)),
        'myRank': value['myRank'],
        'myFinalValue': value['myFinalValue'],
        'myPrizeSummary': value['myPrizeSummary'],
    };
}

